<template>
  <van-cell-group class="mt-2 py-4">
    <van-cell>
      <div class="text-base" slot="title">订单信息</div>
    </van-cell>
    <van-cell>
      <template slot="title">
        <ul>
          <li class="text-gray-500 mt-1">订单号：<span class="text-gray-600">{{ order.trade_no }}</span></li>
          <li class="text-gray-500 mt-1">手机号：<span class="text-gray-600">{{ order.buyer.mobile }}</span></li>
          <li class="text-gray-500 mt-1">消费时间：<span class="text-gray-600">{{ order.used_at ? order.used_at : '-' }}</span></li>
          <li class="text-gray-500 mt-1">付款时间：<span class="text-gray-600">{{ order.paid_at }}</span></li>
          <li class="text-gray-500 mt-1">数量：<span class="text-gray-600">x{{ order.qty }}</span></li>
          <li class="text-gray-500 mt-1">总价：<span class="text-gray-600">￥{{ (order.qty ? order.qty : 0) * (order.price ? order.price : 0) }}</span></li>
          <li class="text-gray-500 mt-1">实付：<span class="text-gray-600">￥{{ order.amount}}</span></li>
        </ul>
      </template>
    </van-cell>
  </van-cell-group>
</template>
<script>
export default {
  props: {
    order: {
      type: Object,
      default: () => {
        return {
          trade_no: '',
          used_at: '',
          paid_at: '',
          qty: '',
          price: '',
          amount: '',
          buyer: {
            mobile: ''
          }
        }
      }
    }
  }
}
</script>
